import { render, staticRenderFns } from "./kartu.vue?vue&type=template&id=3d8458bc"
import script from "./kartu.vue?vue&type=script&lang=js"
export * from "./kartu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports